module.exports = __webpack_public_path__ + "img/蒙版组 1@2x (1)_副本2.fb1cf6fe.webp";